import { toast } from "sonner";

type AnyErr = { status?: number; message?: string; error?: string; context?: { status?: number; body?: unknown } } | string | null | undefined;

const STATUS_MAP: Record<number, { msg: string; type: "error" | "warning" }> = {
  401: { msg: "Sessão expirada — faça login novamente.", type: "error" },
  403: { msg: "Sem permissão para essa ação.", type: "error" },
  402: { msg: "Créditos esgotados — adicione créditos no workspace.", type: "warning" },
  429: { msg: "Limite de requisições atingido — tente em alguns segundos.", type: "warning" },
};

export function notifyError(err: AnyErr, fallback = "Algo deu errado") {
  let status: number | undefined;
  let raw: string = fallback;
  if (typeof err === "string") {
    raw = err;
  } else if (err && typeof err === "object") {
    status = err.status ?? err.context?.status;
    raw = err.message ?? err.error ?? (typeof err.context?.body === "string" ? err.context!.body : fallback);
  }
  if (status && STATUS_MAP[status]) {
    const { msg, type } = STATUS_MAP[status];
    if (type === "warning") toast.warning(msg);
    else toast.error(msg);
    return;
  }
  // tenta detectar mensagem com 402/429 dentro do texto
  const m = /\b(401|402|403|429)\b/.exec(raw);
  if (m) {
    const code = Number(m[1]);
    const mapped = STATUS_MAP[code];
    if (mapped) {
      if (mapped.type === "warning") toast.warning(mapped.msg);
      else toast.error(mapped.msg);
      return;
    }
  }
  toast.error(raw);
}
